export default "__VITE_ASSET__CjMwCiSl__"